// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal-desktop_wrapper__H7Tya","overlay":"modal-desktop_overlay__POMhy"};